import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MessageUtil } from '../../shared/messages/messageUtil';
import { DocumentosListaExibirModel } from '../../shared/models/documentos-lista-exibir.model';
import { DocumentosService } from '../../shared/services/documentos.service';
import { DadosRegulamentosEmprestimos } from '../../shared/util/dados-documentos-regulamentos-emprestimos/dados-regulamentos-emprestimos';

@Component({
  selector: 'app-regulamento',
  templateUrl: './regulamento.component.html',
  styleUrls: ['./regulamento.component.css']
})
export class RegulamentoComponent implements OnInit {

  param: string;

  documentosListaExibirModel: DocumentosListaExibirModel[] = [];

  dadosRegulamentosEmprestimos: DadosRegulamentosEmprestimos[] = [];

  selectedDocumentosListaExibir: DocumentosListaExibirModel;


  idRegulamentoEmprestimo: string;

  constructor(
    private documentosService: DocumentosService,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    this.activatedRoute.url
      .subscribe(arg => this.idRegulamentoEmprestimo = arg[1]['path'].toUpperCase());
  }


  ngOnInit() {
    this.param = '/cardMenus/cardMenuFinanceiro';

    this.getDocumentosRegulamentoEmprestimo();
  }

  private _getDocumentosRegulamento(id: string): Promise<DadosRegulamentosEmprestimos[]> {
    return new Promise(function resolverPromise(resolve) {
      return resolve(DadosRegulamentosEmprestimos.dadosRegulamentoEmprestimos.filter((item) => {
        return item.id.toLowerCase() === id.toLowerCase()
      }))
    })
  }


  async getDocumentosRegulamentoEmprestimo() {
    try {
      console.log(this.idRegulamentoEmprestimo);

      this.dadosRegulamentosEmprestimos = Object.values(await this._getDocumentosRegulamento(this.idRegulamentoEmprestimo));
      this.dadosRegulamentosEmprestimos.map(item => {
        this.documentosListaExibirModel.push(new DocumentosListaExibirModel(item['descricao'], item['caminho'], 'pdf'))
      })
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }


  downloandDocument(documento: DocumentosListaExibirModel): void {
    try {
      this.documentosService.downloandDocument(documento.tipo, documento.caminho);
    } catch (error) {
      console.error(error);

    }

  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/regulamento/regulamento.component.ts